import React from 'react';
import AsyncPage from './async';
import ShowocaseLayout from '../../../../components/layout/ShowocaseLayout';

export default [
  <ShowocaseLayout
    key="/business/showcase/necklace"
    exact
    path="/business/showcase/necklace"
    component={AsyncPage}
  />,
];
